<div class="pt-3 pb-5 competition">
  <app-section-container [isCarausalAvailable]="true">
    <app-section-heading>
      <span class="text__black">Competitions</span>
    </app-section-heading>
    <div>
      <app-section-description>
        <span class="text__black">
          {{ description }}
        </span>
      </app-section-description>
    </div>
    <div
      class="d-flex align-items-center justify-content-md-center justify-content-start gap-2 py-3 competition-chip"
    >
      <div
        class="chip"
        [ngClass]="{
          selected: selectedCategory === CategoryTypes.trending,
        }"
        (click)="
          selectedCategory = CategoryTypes.trending;
          fetchCompetitions(selectedCategory)
        "
        title="Trending Competitions"
      >
        <app-card-chips
          ><span ngProjectAs="[chip-icon]">
            @if (selectedCategory === CategoryTypes.trending) {
            <img
              src="images/trending.svg"
              height="24"
              width="24"
              alt="trending"
            />
            } @else {
            <img
              src="images/trending-black.svg"
              height="24"
              width="24"
              alt="trending"
            />
            }</span
          >Trending Competitions</app-card-chips
        >
      </div>
      <div
        class="chip"
        [ngClass]="{
          selected: selectedCategory === CategoryTypes.newest,
        }"
        (click)="
          selectedCategory = CategoryTypes.newest;
          fetchCompetitions(selectedCategory)
        "
        title="New on AIKosh"
      >
        <app-card-chips>
          <span ngProjectAs="[chip-icon]">
            @if (selectedCategory === CategoryTypes.newest) {
            <img src="images/star-white.svg" height="24" width="25" alt="" />
            } @else {
            <img src="images/star.svg" height="24" width="25" alt="star" />
            }
          </span>
          New on AIKosh</app-card-chips
        >
      </div>
      <a
        class="view-all text-decoration-none"
        [routerLink]="['/', routes.home, routes.competitions, routes.all]"
        title="View All"
      >
        <app-card-chips>
          <img src="images/view-all.svg" height="24" width="25" alt="vie-all" />
          View All</app-card-chips
        >
      </a>
    </div>
    <div class="position-relative pt-5">
      <button
        [ngStyle]="{ visibility: !competitions?.length ? 'hidden' : 'visible' }"
        class="d-flex align-items-center justify-content-center position-absolute hero-carousel-arrow hero-carousel-arrow--prev"
      >
        <img
          src="images/prev-arrow.svg"
          height="14"
          width="10"
          alt="prev arrow"
        />
      </button>

      <div
        class="d-flex align-items-center justify-content-center gap-3"
        [ngClass]="isCompetitionsLoading ? 'd-block' : 'd-none'"
      >
        <app-card-skeleton-loader
          [cardType]="CardType.competition"
        ></app-card-skeleton-loader>
        <div class="d-none d-sm-block">
          <app-card-skeleton-loader
            [cardType]="CardType.competition"
          ></app-card-skeleton-loader>
        </div>
        <div class="d-none d-md-block">
          <app-card-skeleton-loader
            [cardType]="CardType.competition"
          ></app-card-skeleton-loader>
        </div>
        <div class="d-none d-md-block">
          <app-card-skeleton-loader
            [cardType]="CardType.competition"
          ></app-card-skeleton-loader>
        </div>
      </div>

      <div
        [ngClass]="!isCompetitionsLoading ? 'swiper-section d-block' : 'd-none'"
      >
        <swiper-container
          #swiperContainerCompetition
          id="competition-swiper-container"
          init="false"
        >
          @for (competition of competitions; track competition.id) {
          <swiper-slide>
            <div class="hero-carousel h-100">
              <app-competition-card
                [competitionListItem]="competition"
              ></app-competition-card>
            </div>
          </swiper-slide>
          }
        </swiper-container>

        <ng-container *ngIf="!competitions?.length">
          <ng-container *ngIf="isErrorFetchingCompetitions; else noRecordFound">
            <app-couldnt-load-data
              minHeight="25rem"
              (onRetry)="fetchCompetitions(selectedCategory)"
            ></app-couldnt-load-data>
          </ng-container>

          <ng-template #noRecordFound>
            <app-no-record-found></app-no-record-found>
          </ng-template>
        </ng-container>
      </div>

      <button
        [ngStyle]="{ visibility: !competitions?.length ? 'hidden' : 'visible' }"
        class="d-flex align-items-center justify-content-center position-absolute hero-carousel-arrow hero-carousel-arrow--next"
      >
        <img width="10" height="14" src="images/next-arrow.svg" alt="Next" />
      </button>
      <div class="competition-swiper-pagination swiper-pagination"></div>
    </div>
    <!-- <div
      class="d-flex align-items-center justify-content-md-center justify-content-start gap-2 py-3 competition-chip mt-5"
    >
      <a
        class="view-all text-decoration-none"
        [routerLink]="['/', routes.home, routes.competitions, routes.all]"
        title="View All"
      >
        <app-card-chips>
          <img src="images/view-all.svg" height="24" width="25" alt="vie-all" />
          View All Competitions</app-card-chips
        >
      </a>
    </div> -->
  </app-section-container>
</div>
